import { t } from 'i18next';

import { sendFailureAnalytics } from './analytics';

import type { AnalyticsConfig } from 'features/teaming/teaming-base/types';
import { CallNotificationType } from 'features/call/call-events/enums';
import { sendRnsNotification } from 'features/rns/store';
import { setDeafStatus } from 'features/call/call-deaf/store';
import { showNotification } from 'features/notification/store';

export const handleTeamingCallSuccess = (
  _dispatch: any,
  _config: AnalyticsConfig,
  _attemptNumber: number,
  _isAcceptingAgent?: boolean
): void => {
  // Analytics are now handled in the calling thunk (callTeamingRoom)
  // This function can be extended later for non-analytics success handling
};

const executeFailureCleanup = (
  dispatch: any,
  leaveRemoteTeamingThunk: () => void,
  isAcceptingAgent: boolean
): void => {
  dispatch(leaveRemoteTeamingThunk());
  dispatch(
    sendRnsNotification({
      eventName: CallNotificationType.TEAMING_USER_COULD_NOT_CONNECT_TO_TEAMING,
      data: {
        wasAcceptingAgent: isAcceptingAgent,
      },
    })
  );
  dispatch(setDeafStatus('disconnected'));
};

export const handleCallFailure = (
  dispatch: any,
  config: AnalyticsConfig,
  isAcceptingAgent: boolean,
  attemptsExhausted: number,
  leaveRemoteTeamingThunk: () => void
): void => {
  sendFailureAnalytics(dispatch, config, attemptsExhausted);
  dispatch(
    showNotification({
      severity: 'error',
      title: t('teamNotification.couldNotConnectToTeaming'),
    })
  );

  if (isAcceptingAgent) {
    // If we are the accepting agent, leave immediately
    executeFailureCleanup(dispatch, leaveRemoteTeamingThunk, isAcceptingAgent);
  } else {
    // If we are not the accepting agent, wait 2.5 seconds before leaving
    // in case both VIs cannot join the teaming room
    setTimeout(() => {
      executeFailureCleanup(
        dispatch,
        leaveRemoteTeamingThunk,
        isAcceptingAgent
      );
    }, 2500);
  }
};
